<template>
	<div id="app">
		<router-view></router-view>
		<image-dialog ref="imageDialog"  :max="maxChooseImage"></image-dialog>
		<i class="iconfont"></i>

	</div>
</template>

<script>
	import "@/assets/icofont/iconfont.css";
	import imageDialog from '@/components/image/image-dialog.vue';
	export default {
		components: {
			imageDialog
		},
		name: 'app',
		// 依赖註入
		provide() {
			return {

				app: this,
				
			}
		},
		
		data() {
			return {
				maxChooseImage: 9,
				path: ''
			}
		},
		methods: {
			chooseImage(callback, max = 9) {
				this.maxChooseImage = max
				this.$refs.imageDialog.chooseImage(callback)
			}
		}


	}
</script>

<style>
	::-webkit-scrollbar-track {
		background: rgba(0, 0, 0, .1);
		border-radius: 0;
	}

	::-webkit-scrollbar {
		-webkit-appearance: none;
		width: 2px;
		height: 2px;
	}

	::-webkit-scrollbar-thumb {
		cursor: pointer;
		border-radius: 5px;
		background: rgba(0, 0, 0, .25);
		transition: color .2s ease;
	}
	.el-icon-circle-close{
		color: #fff;
	}
	
	.all_foot_page{
		bottom: 0;width: 100%;z-index: 100;margin-left: -16px;
		overflow-x: auto;
	}
	
	.menu_float{
		width: auto;
		position: absolute;
		top: 60px;
		height: 100%;
		z-index: 1000;
	}
	
	
	.text-blue{
		color: #409EFF;
	}
	.text-a{
		cursor: pointer;
	}
	
	
	.el-table__expand-icon{
		height: 25px!important;
	}
	.el-table__expand-icon .el-icon-arrow-right{
		/* color: #409EFF;
		font-weight: bolder;
		font-size: 20px; */
	}
	.el-table .blue-row {
	   background: #f3f5fe;
	 }
	 .order_tabs .el-tabs--border-card > .el-tabs__content{
		 padding: 0;
	 }
	

	/* .el-breadcrumb__inner.is-link:hover, .el-breadcrumb__inner a:hover{
		color: #ffb58a!important;
	}
	.el-input__inner:focus {
		border-color: #ffb58a!important;
	}
	.el-select-dropdown__item.selected {
		color: #333!important;
	}
	.el-date-table td.start-date span, .el-date-table td.end-date span {
		background-color: #ffb58a!important;
	}
	.el-picker-panel__shortcut:hover {
		color:  #ffb58a!important;
	}
	.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
		background-color: #fff7f3!important;
	}
	.el-button--info {
		color: #fff!important;
		background-color: #ff9561!important;
		border-color: #ff9561!important;
	}
	.el-button--info:hover, .el-button--info:focus {
		color: #fff!important;
		background-color: #ffb58a!important;
		border-color: #ffb58a!important;
	} */
	.el-form-item__label {
		font-size: 12px!important;
	}
	.el-range-editor--small .el-range-input {
		font-size: 12px!important;
	}
	.el-select-dropdown__empty {
		font-size: 12px!important;
	}
	/* .el-range-editor.is-active:hover {
		border-color:  #ffb58a!important;
	}
	.el-date-table td.today span {
		color: #ffb58a!important;
	}
	.el-button:hover, .el-button:focus {
		color: #ffb58a!important;
		background-color: #fff!important;
		border-color: #ffb58a!important;
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color:#ffb58a!important;
		color: #FFFFFF!important;
	}
	.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #ffb58a!important;
	}

	.el-pagination__sizes .el-input .el-input__inner:hover {
		border-color: #ffb58a!important;
	}
	.el-radio.is-bordered.is-checked {
		border-color: #ffb58a!important;
	}
	.el-radio__input.is-checked + .el-radio__label {
		color: #ffb58a!important;
	}
	.el-radio__input.is-checked .el-radio__inner {
		border-color: #ffb58a!important;
		background: #ffb58a!important;
	}
	.el-button--primary {
		color: #FFFFFF!important;
		background-color: #ffb58a!important;
		border-color: #ffb58a!important;
	}
	.el-button--primary.is-plain {
		color: #f66b1b!important;
		background: #ffe4d4!important;
		border-color: #fdb48d!important;
	} */
	.el-table__body tr:hover > td {
		background-color: #fff9f5!important;
	}
	.el-select-dropdown__item {
    	font-size: 12px!important;
	}
	.el-table__header th {
		background-color: #f0f2f5!important;
	}
	.el-table .cell {
		font-weight: 400!important;
	}
	.text_chengse{
		color: #ff9561;
	}
	
	.noth .el-table__header th{
		display: none!important;
	}
</style>
